import { useQuery } from "@tanstack/react-query";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_FEEDBACK } from "@/constants/resultsLimits";

interface Feedback {
  device: {
    id: string;
  };
  author: {
    id: string;
  };
  feedbackStatus: "Valid" | "Dismissed";
  feedbackTargetId: string;
  feedbackType: "collisionDetection";
  submittedOn: string;
}

export const useFeedback = (targetId: string) => {
  const { activeSessionId, geotabClient } = useGeotabClient();

  return useQuery<Feedback[]>({
    queryKey: ["feedback", activeSessionId, targetId],
    queryFn: async ({ signal }) => {
      const result = (await geotabClient.call(
        "Get",
        {
          typeName: "Feedback",
          search: {
            feedbackTargetId: targetId,
            feedbackType: "collisionDetection",
          },
          resultsLimit: RESULTS_LIMIT_FEEDBACK,
        },
        signal,
      )) as Feedback[] | null;
      return result ?? [];
    },
  });
};
